export default __webpack_public_path__ + "static/media/tennis-ball-icon-white.2a4938cd.svg";